import { Waves } from "lucide-react";

export function LoadingScreen({ label = "Loading…" }: { label?: string }) {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-4 bg-background text-foreground">
      <Waves className="w-8 h-8 text-primary animate-pulse" />
      <p className="text-sm text-muted-foreground">{label}</p>
    </div>
  );
}
